import { render, staticRenderFns } from "./index.vue?vue&type=template&id=747c0466&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=747c0466&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747c0466",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('747c0466')) {
      api.createRecord('747c0466', component.options)
    } else {
      api.reload('747c0466', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=747c0466&scoped=true&lang=pug", function () {
      api.rerender('747c0466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/loginModal/index.vue"
export default component.exports